import {useQuery} from 'react-query';
import getDetailShopCard from '.';



const useGetDetailShopCard = (payload: IPayload) => {
  const {data, isLoading} = useQuery(['shop-card-detail', payload.guid], () =>
    getDetailShopCard(payload),
  );
  return {cardDetailData: data, isLoading};
};

export default useGetDetailShopCard;
